import React from 'react';
import { Typography } from '@mui/material';
import PageLayout from './PageLayout';

interface ErrorPageProps {
  error: string;
}

const ErrorPage: React.FC<ErrorPageProps> = ({ error }) => (
  <PageLayout>
    <Typography variant="h5" color="error" gutterBottom>
      Ocurrió un error
    </Typography>
    <Typography color="textSecondary">{error}</Typography>
  </PageLayout>
);

export default ErrorPage;
